import { i18nTranslate } from 'src/utils'

const renderUserFilterInput = infoProps => {
  const { defaultSearchContract } = infoProps
  const filterInputs = [
    {
      name: 'searchContract',
      type: 'search',
      columnType: {
        lg: '9',
        md: '9',
      },
      customClassName: 'pr-0 pr-md-2',
      dataTestId: 'qa-search',
      defaultValue: defaultSearchContract,
      placeHolderText: i18nTranslate('contract.searchId', 'Search ID'),
    },
  ]
  return filterInputs
}
export { renderUserFilterInput }
